import AppCard from '@nxsys/components/AppCard';
import { useDashboardEmployerAnalytics } from './context/DashboardEmployerAnalyticsContext';
import { formatNumber } from '@nxsys/utils/number-helper';
import { useMemo } from 'react';

const EmployeeStatus = () => {
  const { employeeStatus: data, loading } = useDashboardEmployerAnalytics();

  const items = useMemo(
    () => [
      {
        title: loading ? '—' : formatNumber(data?.activeEmployee ?? 0),
        description: 'Active Employee',
        bgColor: '#F3F9F0',
        iconColor: '#83BF6E',
      },
      {
        title: loading ? '—' : formatNumber(data?.leaver ?? 0),
        description: 'Leaver',
        bgColor: '#FFF4E9',
        iconColor: '#FFBC99',
      },
      // {
      //   title: loading ? '—' : formatNumber(data?.missingInformation ?? 0),
      //   description: 'Missing Information',
      //   bgColor: '#FDF1F0',
      //   iconColor: '#FF383C',
      // },
    ],
    [data, loading],
  );

  return (
    <div className="EmployerTaxPeriod h-full">
      <AppCard title="Employee Status" className="h-full">
        <div className="grid grid-cols-2 gap-[16px] max-sm:grid-cols-1 p-[16px]">
          {items.map((item) => (
            <div
              key={item.description}
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px] flex flex-col"
              style={{ backgroundColor: item.bgColor }}
            >
              <div className="text-[40px] font-bold mb-[8px]">{item.title}</div>
              <div className="flex items-center gap-x-[4px] flex-1">
                <div className="text-[12px] flex-1">{item.description}</div>
                <div
                  className="w-[16px] h-[16px] rounded-full p-[3px] border"
                  style={{ borderColor: '#000000' }}
                >
                  <div
                    className="w-full h-full rounded-full"
                    style={{ backgroundColor: item.iconColor }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </AppCard>
    </div>
  );
};

export default EmployeeStatus;
